// middleware/closeModal.global.js

import { useModalStore } from '../stores/modal'

export default defineNuxtRouteMiddleware((to, from) => {
  if (!from.name) return
  // 페이지 전환 시 모달 닫기
  const modalStore = useModalStore();
  modalStore.closeModalAlert();
});